import { initMobileNav } from './mobile';
import { initDesktopNav } from './desktop';

export const initNavigation = () => {
  initMobileNav();
  initDesktopNav();
};
